import styled, { ITheme } from '../../theme'

const FormSideContainer = styled.div`
  display: inline-block;
  width: 50%;
  padding: 0px 20px;
  &::after {
    clear: both;
  }

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    width: 100%;
    padding-bottom: 20px;
  }
`

export default FormSideContainer
